import React from "react";

export default function Footer({ displayName, initials }) {
  return (
    <footer className="addin-footer">
      <div className="footer-user">
        <div className="user-avatar">{initials}</div>
        <div>
          <div className="footer-name">{displayName}</div>
        </div>
      </div>
    </footer>
  );
}
